var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bin"},[_c('span',{staticClass:"TotleTit"},[_vm._v(_vm._s(_vm.information.tit))]),_c('div',{ref:"Dpsie",staticClass:"Dpie"})])
}
var staticRenderFns = []

export { render, staticRenderFns }